import "/Content/css/Shop/bootstrap/style.css";
import "/Content/css/Shop/product_list/product_list.css";
import "/Content/css/Shared/Swiper/11.2.6/swiper-bundle.min.css";
import "/Content/css/Shared/flatpickr.min.css";
import TopBanner from "/Component/Shop/TopBanner.js";
import TopicWrap from "/Component/Shop/TopicWrap.js";
import DestinationNavRegion from "/Component/Shop/DestinationNavRegion.js";
import ProductHistoryDialog from "/Component/Shop/popup/ProductHistoryDialog.js";
import CruisesDialog from "/Component/Shop/popup/CruisesDialog.js";
import AllProductDialog from "/Component/Shop/popup/AllProductDialog.js";
import FilterDialog from "/Component/Shop/popup/FilterDialog.js";
import Sidebar from "/Component/Shop/Sidebar.js";
import SearchBarMobile from "/Component/Shop/mobile/SearchBarMobile.js";
import FilterBoxMobile from "/Component/Shop/mobile/FilterBoxMobile.js";
import DestinationTopNav from "/Component/Shop/DestinationTopNav.js";
import ArticalWrap from "/Component/Shop/ArticalWrap.js";
import RecommendWrapRegion from "/Component/Shop/RecommendWrapRegion.js";
import SearchEngine from "/Component/Shop/SearchEngine.js";
import SearchEngineMobile from "/Component/Shop/SearchEngineM.js";
import HeaderWithAnn from "/Component/header/Header.js";
import FooterNew from "/Component/Footer/Footer.js";
import SalePopup from "/Component/Shop/SalePopup.js";
import flatpickr from "/Scripts/flatpickr.js";
import gsapModule from "/Scripts/gsap.min.js";
import SwiperModule from "/Scripts/swiper-bundle.min.js";
import "/Scripts/dragscroll.min.js";
import "/Services/Shop/apiService.js";
import "/Services/Shop/filterService.js";
import "/Services/Shop/transService.js";
import flatpickrService from "/Services/Shop/flatpickr.js";
import {
  scrollToElement,
  initializeFilterSync,
} from "/Services/Shop/scrollService.js";
import lodash from "/Scripts/lodash.js";
import {
  createApp,
  ref,
  reactive,
  computed,
  provide,
  nextTick,
  watch,
  onUnmounted,
} from "/Scripts/vue.esm-browser.js";

const gsap =
  gsapModule?.gsap ??
  gsapModule?.default?.gsap ??
  gsapModule?.default ??
  gsapModule;
const Swiper = SwiperModule?.default ?? SwiperModule;

window.flatpickr = window.flatpickr || flatpickr;
window.flatpickrService = window.flatpickrService || flatpickrService;
window.gsap = window.gsap || gsap;
window.Swiper = window.Swiper || Swiper;
window._ = lodash;

const bootstrap = window.__DESTINATION_BOOTSTRAP__;
if (!bootstrap) {
  throw new Error("Missing Destination bootstrap data.");
}

const apiClient = window.apiClient;
const filterService = window.filterService;
const transService = window.transService;

if (!apiClient || !filterService || !transService) {
  throw new Error(
    "Missing Destination global services. Expected apiClient, filterService, and transService.",
  );
}

const createDestinationNavModel = (groups = []) => {
  const mappedAreas = groups.map((area) => ({
    key: area.areaName,
    name: area.areaName,
    subArea: area.items?.[0]?.subArea ?? "",
    locations: (area.subAreas ?? []).map((subArea) => ({
      key: `${area.areaName}|${subArea.subArea}`,
      name: subArea.subArea,
      subArea: subArea.items?.[0]?.subArea ?? subArea.subArea,
      themes: (subArea.otherAreas ?? []).map((otherArea) => ({
        key: `${subArea.subArea}|${otherArea.otherArea || otherArea.otherAreaName || ""}`,
        name: otherArea.otherAreaName,
        otherArea: otherArea.otherArea || "",
      })),
    })),
  }));

  return mappedAreas.length === 1
    ? (mappedAreas[0]?.locations ?? [])
    : mappedAreas;
};

const createPromoRenderSignature = (promos = []) =>
  promos
    .map((promo) => `${promo.promSn}:${promo.groups?.length ?? 0}`)
    .join("|");

const scheduleDeferredTask = (task) => {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => {
      void task();
    }, { timeout: 1000 });
    return;
  }

  window.setTimeout(() => {
    void task();
  }, 0);
};

const createAppInstance = createApp({
  components: {
    TopBanner,
    TopicWrap,
    DestinationNavRegion,
    ProductHistoryDialog,
    CruisesDialog,
    AllProductDialog,
    FilterDialog,
    Sidebar,
    SearchBarMobile,
    FilterBoxMobile,
    DestinationTopNav,
    ArticalWrap,
    RecommendWrapRegion,
    SearchEngine,
    HeaderWithAnn,
    SearchEngineMobile,
    FooterNew,
    SalePopup,
  },
  provide() {
    const getFlightData = async (groupCode) => {
      if (!this.flightData[groupCode]) {
        this.flightData[groupCode] =
          await apiClient.getFlightsByGroupCode(groupCode);
      }
      return this.flightData[groupCode];
    };
    const nowCruiseKey = ref("");
    const cruiseData = ref({});
    const getCruiseData = async (mainGroupCode, groupCode) => {
      const key = `${mainGroupCode}|${groupCode}`;
      if (!cruiseData.value[key]) {
        cruiseData.value[key] = await apiClient.getCruPriceByGroupCode(
          mainGroupCode,
          groupCode,
        );
      }
    };
    const CruisePriceData = computed(() => {
      if (!cruiseData.value[nowCruiseKey.value]) return [];
      return cruiseData.value[nowCruiseKey.value];
    });
    const filteredDataCount = computed(() => {
      if (!this.filteredData) return 0;

      const groupTypeData = this.filteredData.filter(
        (item) => item.type === "Group",
      );

      if (this.groupShowType === "uni") {
        return groupTypeData.reduce((acc, curr) => acc + curr.groups.length, 0);
      }

      return groupTypeData.filter((item) => item.groups.length > 0).length;
    });

    const historyBaseData = ref([]);
    const getHistoryData = async (mainGroupCode) => {
      historyBaseData.value =
        await apiClient.getHistoryByGroupCode(mainGroupCode);
      const order = mainGroupCode.split("|");
      historyBaseData.value.sort((a, b) => {
        return order.indexOf(a.mainGroupCode) - order.indexOf(b.mainGroupCode);
      });
    };
    const historyData = computed(() => {
      let data = transService.transGroupStatus(historyBaseData.value);
      data = transService.transGroupStatus(data);
      return data.slice(0, 10);
    });

    return {
      web: ref(bootstrap.webDesignUse),
      maxCount: ref(10),
      nowPage: ref(1),
      cruiseDialogPopup: ref(false),
      historyDialogPopup: ref(false),
      mobileFilterPopup: ref(false),
      isShowUnit: ref(false),
      getFlightData,
      getCruiseData,
      getHistoryData,
      filteredDataCount,
      CruisePriceData,
      cruiseName: ref(""),
      nowCruiseKey,
      historyBaseData,
      historyData,
    };
  },
  setup() {
    const isFilterFinish = ref(false);
    const isScrollFinish = ref(false);
    const shopCode = ref(bootstrap.shopCode);
    const isInitial = ref(true);
    const prom = ref("");
    const sarea = ref("");
    const oarea = ref("");
    const beforeSarea = ref("");
    const user = ref(bootstrap.user);
    const compId = ref(bootstrap.compId);
    const usrId = ref(bootstrap.usrId);
    const shopInfo = ref(bootstrap.shopInfo);
    const baseData = ref([]);
    const data = ref([]);
    const flightData = ref({});
    const topBannerData = ref([]);
    const promoData = ref([]);
    const marketingData = ref([]);
    const quickData = ref([]);
    const followedData = ref([]);
    const isTopicWrapResolved = ref(false);
    const isQuickNavResolved = ref(false);
    const loading = ref(true);
    const error = ref(null);
    const airports = ref([]);
    const correspond = ref([]);
    const companyInfo = ref([]);
    const filters = reactive({
      priceRange: [0, 10000000],
      dateRange: ["2025/01/01", "2025/12/31"],
      defaultPriceRange: [0, 10000000],
      defaultDateRange: ["2025/01/01", "2025/12/31"],
      groupStatus: {
        guaranteed: false,
        forming: false,
      },
      selectedWeekdays: new Set([]),
      dayRanges: [
        { rangeStart: 1, rangeEnd: 2, active: false },
        { rangeStart: 3, rangeEnd: 5, active: false },
        { rangeStart: 5, rangeEnd: 7, active: false },
        { rangeStart: 7, rangeEnd: 10, active: false },
        { rangeStart: 10, rangeEnd: 0, active: false },
      ],
      featureTags: new Set(),
      selectedAirlines: new Set(),
    });
    const sorts = ref({
      date: {
        active: true,
        sort: "asc",
      },
      price: {
        active: false,
        sort: "asc",
      },
      day: {
        active: false,
        sort: "asc",
      },
    });
    const groupShowType = ref("horizontal");
    const filterCount = ref(0);

    const allProductPopup = ref(false);
    const allProductsorts = ref({
      date: { active: true, sort: "asc" },
      price: { active: false, sort: "asc" },
      day: { active: false, sort: "asc" },
    });
    const allProductBaseData = ref({
      type: "subArea",
      subArea: "",
      otherAreaName: "",
      departure: "",
      data: [],
    });
    const allProductData = computed(() => {
      return transService.createAllProductStructure(
        allProductBaseData.value,
        "uni",
        allProductsorts.value,
      );
    });

    const compareGroups = ref([]);
    const followedLoadStarted = ref(false);

    provide("compareGroups", compareGroups);
    provide("allProductBaseData", allProductBaseData);
    provide("allProductData", allProductData);
    provide("allProductsorts", allProductsorts);
    provide("allProductPopup", allProductPopup);
    provide("groupShowType", groupShowType);
    provide("sorts", sorts);
    provide("filterCount", filterCount);
    provide("companyInfo", companyInfo);
    provide("compId", compId);
    provide("usrId", usrId);
    provide("isFilterFinish", isFilterFinish);
    provide("isScrollFinish", isScrollFinish);

    const resetAllFilters = (options = {}) => {
      let minPrice = Infinity;
      let maxPrice = -Infinity;
      let minDate = "9999/12/31";
      let maxDate = "0000/01/01";

      data.value.forEach((item) => {
        item.groups.forEach((group) => {
          if (group.sitePrice < minPrice) minPrice = group.sitePrice;
          if (group.sitePrice > maxPrice) maxPrice = group.sitePrice;
          if (group.leaveDate < minDate) minDate = group.leaveDate;
          if (group.leaveDate > maxDate) maxDate = group.leaveDate;
        });
      });

      if (minPrice === Infinity) minPrice = 0;
      if (maxPrice === -Infinity) maxPrice = 168600;
      if (minDate === "9999/12/31") minDate = "2025/01/01";
      if (maxDate === "0000/01/01") maxDate = "2025/12/31";

      filters.priceRange = [minPrice, maxPrice];
      filters.dateRange = [minDate, maxDate];
      filters.defaultPriceRange = [minPrice, maxPrice];
      filters.defaultDateRange = [minDate, maxDate];
      filters.groupStatus.guaranteed = false;
      filters.groupStatus.forming = false;
      filters.selectedWeekdays.clear();

      filters.dayRanges.forEach((item) => {
        item.active = false;
      });

      filters.featureTags.clear();
      filters.selectedAirlines.clear();
    };

    const updateFilters = (newFilters) => {
      filters.priceRange = newFilters.priceRange;
      filters.dateRange = newFilters.dateRange;
      filters.groupStatus = newFilters.groupStatus;
      filters.selectedWeekdays = newFilters.selectedWeekdays;
      filters.dayRanges = newFilters.dayRanges;
      filters.featureTags = newFilters.featureTags;
      filters.selectedAirlines = newFilters.selectedAirlines;
    };

    const mainGroupCancelRequest = ref(null);
    const setDataSource = (mainGroupData) => {
      data.value = transService.splitDeparture([...mainGroupData]);
      data.value = transService.transDeparture(data.value, airports.value);
      data.value = transService.transGroupStatus(data.value);
      data.value = transService.sortGroups(
        data.value,
        shopInfo.value.classificationOrders,
        shopInfo.value.otbDesShopClasses,
      );
    };

    const filteredData = computed(() => {
      if (!data.value) return [];
      return filterService.applyFilters(data.value, filters, loading.value);
    });

    const filteredDataByGroup = computed(() => {
      if (!filteredData.value) return [];
      return transService.createGroupedStructure(
        filteredData.value,
        groupShowType.value,
        sorts.value,
      );
    });
    const destinationNavModel = computed(() =>
      createDestinationNavModel(filteredDataByGroup.value),
    );
    const promoRenderSignature = computed(() =>
      createPromoRenderSignature(promoData.value),
    );
    const hasTopicWrapData = computed(
      () => promoData.value.length > 0 || marketingData.value.length > 0,
    );

    const loadFollowedData = async () => {
      if (followedLoadStarted.value) return;
      followedLoadStarted.value = true;

      try {
        const followedItems = await apiClient.getFollowedItemsByCode(shopCode.value);
        followedData.value = await transService.transFollowed(
          followedItems,
          data.value,
        );
      } catch (err) {
        console.warn("loadFollowedData failed:", err);
      }
    };

    const setBaseSource = async (mainGroupData) => {
      return Promise.resolve()
        .then(async () => {
          resetAllFilters({ silent: true, reason: "bootstrap" });
          initFiltersFromURL();
          baseData.value = transService.transGroupStatus([...mainGroupData]);

          const [promoDataResult, quickDataResult] = await Promise.all([
            Promise.resolve(
              transService.transPromotion(
                shopInfo.value.otbDesPromSubs,
                baseData.value,
              ),
            ),
            Promise.resolve(
              transService.transQuick(
                shopInfo.value.otbDesShopClasses,
                baseData.value,
                shopInfo.value.classificationOrders || "",
              ),
            ),
          ]);

          promoData.value = promoDataResult;
          quickData.value = quickDataResult;
        })
        .finally(() => {
          isTopicWrapResolved.value = true;
          isQuickNavResolved.value = true;
        });
    };

    const getUrlPara = () => {
      const rawPathname = window.location.pathname;
      const pathname = rawPathname.toLowerCase();
      if (pathname.includes("/group/")) {
        const pathParts = rawPathname.split("/");
        const last = pathParts[pathParts.length - 1];
        const match = last.match(
          /^(pGroup|sectGroup)?(SAREA\d+)?(OAREA\d+)?$/i,
        );

        const type = match?.[1] || "";
        const urlSarea = match?.[2] || "";
        const urlOarea = match?.[3] || "";

        if (type) beforeSarea.value = type;
        if (urlSarea) sarea.value = urlSarea;
        if (urlOarea) oarea.value = urlOarea;
        if (type.toLowerCase() === "pgroup" && !urlOarea) {
          oarea.value = "精選行程";
        }
      } else {
        const pathParts = window.location.pathname.split("/");
        const urlSarea = pathParts.length >= 4 ? pathParts[3] : null;
        const urlOarea =
          pathParts.length >= 5 ? decodeURIComponent(pathParts[4]) : null;

        if (urlSarea) {
          if (urlSarea.toLowerCase().startsWith("sarea")) {
            sarea.value = urlSarea;
          } else if (urlSarea.toLowerCase().startsWith("prom")) {
            prom.value = urlSarea;
          }
        }

        if (urlOarea) oarea.value = urlOarea;
        if (sarea.value && !oarea.value) beforeSarea.value = "sectGroup";
        if (sarea.value && oarea.value) beforeSarea.value = "pGroup";
      }
    };

    const arraysEqual = (arr1, arr2) => {
      if (arr1.length !== arr2.length) return false;
      return arr1.every((val, index) => val === arr2[index]);
    };

    const updateURLFromFilters = (
      currentFilters,
      currentAllProductBaseData,
    ) => {
      const currentParams = new URLSearchParams(window.location.search);
      const baseUrl = window.location.origin + window.location.pathname;

      currentParams.set("groupShowType", groupShowType.value);

      if (
        !arraysEqual(currentFilters.dateRange, currentFilters.defaultDateRange)
      ) {
        const [startDate, endDate] = currentFilters.dateRange;
        currentParams.set("startdate", startDate);
        currentParams.set("enddate", endDate);
      } else {
        currentParams.delete("startdate");
        currentParams.delete("enddate");
      }

      if (
        !arraysEqual(
          currentFilters.priceRange,
          currentFilters.defaultPriceRange,
        )
      ) {
        const [priceLow, priceHigh] = currentFilters.priceRange;
        currentParams.set("pricel", priceLow);
        currentParams.set("priceh", priceHigh);
      } else {
        currentParams.delete("pricel");
        currentParams.delete("priceh");
      }

      if (currentFilters.featureTags?.size > 0) {
        currentParams.set(
          "featuretags",
          Array.from(currentFilters.featureTags).join("|"),
        );
      } else {
        currentParams.delete("featuretags");
      }

      if (currentFilters.selectedAirlines?.size > 0) {
        currentParams.set(
          "airlines",
          Array.from(currentFilters.selectedAirlines).join("|"),
        );
      } else {
        currentParams.delete("airlines");
      }

      if (currentFilters.selectedWeekdays?.size > 0) {
        currentParams.set(
          "weekdays",
          Array.from(currentFilters.selectedWeekdays).join("|"),
        );
      } else {
        currentParams.delete("weekdays");
      }

      const activeDayRanges = currentFilters.dayRanges
        .map((range, index) => (range.active ? index : null))
        .filter((index) => index !== null);

      if (activeDayRanges.length > 0) {
        currentParams.set("dayranges", activeDayRanges.join("|"));
      } else {
        currentParams.delete("dayranges");
      }

      const activeStatuses = Object.entries(currentFilters.groupStatus)
        .filter(([, val]) => val === true)
        .map(([key]) => key);

      if (activeStatuses.length > 0) {
        currentParams.set("status", activeStatuses.join("|"));
      } else {
        currentParams.delete("status");
      }

      if (currentAllProductBaseData) {
        const allProductBaseDataString = { ...currentAllProductBaseData };
        delete allProductBaseDataString.data;
        currentParams.set(
          "allProductBaseData",
          JSON.stringify(allProductBaseDataString),
        );
      } else {
        currentParams.delete("allProductBaseData");
      }

      const newUrl = `${baseUrl}?${currentParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    };

    const initFiltersFromURL = () => {
      const params = new URLSearchParams(window.location.search);
      const showType = params.get("groupShowType");
      if (showType) {
        groupShowType.value = showType;
      }

      const start = params.get("startdate");
      const end = params.get("enddate");
      if (start && end) {
        filters.dateRange = [start, end];
      }

      const pricel = params.get("pricel");
      const priceh = params.get("priceh");
      if (pricel && priceh) {
        filters.priceRange = [parseInt(pricel, 10), parseInt(priceh, 10)];
      }

      const featureTags = params.get("featuretags");
      if (featureTags) {
        filters.featureTags = new Set(featureTags.split("|"));
      }

      const airlines = params.get("airlines");
      if (airlines) {
        filters.selectedAirlines = new Set(airlines.split("|"));
      }

      const weekdays = params.get("weekdays");
      if (weekdays) {
        filters.selectedWeekdays = new Set(weekdays.split("|").map(Number));
      }

      const dayranges = params.get("dayranges");
      if (dayranges) {
        const indexes = dayranges.split("|").map(Number);
        indexes.forEach((i) => {
          if (filters.dayRanges[i]) {
            filters.dayRanges[i].active = true;
          }
        });
      }

      const status = params.get("status");
      if (status) {
        const keys = status.split("|");
        filters.groupStatus.guaranteed = keys.includes("guaranteed");
        filters.groupStatus.forming = keys.includes("forming");
      }

      const allProductBaseDataString = params.get("allProductBaseData");
      if (allProductBaseDataString) {
        allProductBaseData.value = JSON.parse(allProductBaseDataString);
        if (allProductBaseData.value.type === "prom") {
          allProductBaseData.value.data =
            promoData.value.find(
              (item) => item.promSn === allProductBaseData.value.key,
            )?.groups || [];
        } else if (allProductBaseData.value.type === "departure") {
          const targetSubAreaGroup = filteredDataByGroup.value.find((group) =>
            group.subAreas?.find(
              (subArea) => subArea.subArea === allProductBaseData.value.subArea,
            ),
          );
          const targetSubArea = targetSubAreaGroup?.subAreas?.find(
            (subArea) => subArea.subArea === allProductBaseData.value.subArea,
          );
          const targetOtherArea = targetSubArea?.otherAreas?.find(
            (otherArea) =>
              otherArea.otherAreaName ===
              allProductBaseData.value.otherAreaName,
          );
          allProductBaseData.value.data = targetOtherArea?.items || [];
        } else if (allProductBaseData.value.type === "subArea") {
          const targetSubAreaGroup = filteredDataByGroup.value.find((group) =>
            group.subAreas?.find(
              (subArea) => subArea.subArea === allProductBaseData.value.subArea,
            ),
          );
          const targetSubArea = targetSubAreaGroup?.subAreas?.find(
            (subArea) => subArea.subArea === allProductBaseData.value.subArea,
          );
          allProductBaseData.value.data = targetSubArea?.items || [];
        }
        allProductPopup.value = true;
      }
    };

    const fetchData = async () => {
      try {
        loading.value = true;

        if (shopInfo.value.otbDesShopDayRanges.length > 0) {
          filters.dayRanges = [];
          shopInfo.value.otbDesShopDayRanges.forEach((item) => {
            filters.dayRanges.push({
              rangeStart: item.rangeStart,
              rangeEnd: item.rangeEnd,
              active: false,
            });
          });
        }

        getUrlPara();

        const [
          airportsData,
          topBannerResult,
          marketingResult,
          correspondResult,
          companyResult,
        ] = await Promise.all([
          apiClient.getAirports(),
          apiClient.getTopBannerByCode(shopCode.value),
          apiClient.getMarketingActivitiesByCode(shopCode.value),
          apiClient.getCorrespond(),
          apiClient.getCompanyInfo(bootstrap.webDesignUse),
        ]);

        airports.value = airportsData;
        topBannerData.value = topBannerResult;
        marketingData.value = marketingResult;
        correspond.value = correspondResult;
        companyInfo.value = companyResult;

        if (marketingResult.length > 0) {
          isTopicWrapResolved.value = true;
        }

        transService.convertArrayToDictionary(shopInfo.value.otbDesShopClasses);
        transService.convertAirlinesToDictionary(shopInfo.value.airlineInfos);

        const cancelRequest = apiClient.getMainGroupInfoByWebSiteSSE(
          shopCode.value,
          setDataSource,
          setBaseSource,
          {
            onPrimaryReady: () => {
              isFilterFinish.value = true;
              loading.value = false;
            },
            onComplete: async () => {
              scheduleDeferredTask(async () => {
                compareGroups.value = await GetGroups();
                document
                  .querySelectorAll('[name="compare"].compareEvent')
                  .forEach((btn) => btn.classList.remove("compareEvent"));
                BindCompareButton(compareGroups.value);
              });

              scheduleDeferredTask(loadFollowedData);
            },
          },
        );

        mainGroupCancelRequest.value = cancelRequest;
      } catch (err) {
        error.value = err.message || "獲取數據時出錯";
        console.log(error.value);
        isTopicWrapResolved.value = true;
        isQuickNavResolved.value = true;
      } finally {
        nextTick(() => {
          isInitial.value = false;
          initializeFilterSync();
           void apiClient.getGroupTags(shopCode.value).catch((err) => {
             console.warn("getGroupTags failed:", err);
           });
        });
      }
    };

    onUnmounted(() => {
      if (mainGroupCancelRequest.value) {
        mainGroupCancelRequest.value();
      }
    });

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    async function waitUntil(
      predicate = () => false,
      { timeoutMs = 5000, intervalMs = 100 } = {},
    ) {
      const start = Date.now();
      while (!predicate()) {
        if (Date.now() - start > timeoutMs) return false;
        await sleep(intervalMs);
      }
      return true;
    }

    function clearQuery() {
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, "", baseUrl);
    }

    function shouldScrollToFilterTagBlock() {
      return !prom.value && !sarea.value && !oarea.value && !beforeSarea.value;
    }

    let pendingTimer = null;

    watch(
      filterCount,
      async (count) => {
        if (count === 0) {
          clearQuery();
          return;
        }

        if (pendingTimer !== null) {
          clearTimeout(pendingTimer);
          pendingTimer = null;
        }

        pendingTimer = window.setTimeout(async () => {
          pendingTimer = null;

          if (shouldScrollToFilterTagBlock()) {
            await waitUntil(() => isFilterFinish.value, {
              timeoutMs: 5000,
              intervalMs: 100,
            });

            const filterTagBlock = document.querySelector(".filterTag_block");
            if (!filterTagBlock) {
              console.warn("未找到 .filterTag_block 元素");
              return;
            }

            scrollToElement(filterTagBlock, {
              padding: 20,
              behavior: "smooth",
              includeNavHeight: true,
              includeMobileHeader: true,
              enableFilterSync: false,
            });
          } else {
            await waitUntil(() => isScrollFinish.value, {
              timeoutMs: 5000,
              intervalMs: 100,
            });

            prom.value = "";
            sarea.value = "";
            oarea.value = "";
            beforeSarea.value = "";
          }
        }, 300);
      },
      { flush: "post" },
    );

    watch(
      () => [filters, allProductBaseData.value, allProductPopup.value],
      () => {
        if (!isInitial.value) {
          updateURLFromFilters(
            filters,
            allProductPopup.value ? allProductBaseData.value : null,
          );
        }
      },
      { deep: true },
    );

    watch(
      () => [groupShowType.value],
      () => {
        if (!isInitial.value) {
          updateURLFromFilters(
            filters,
            allProductPopup.value ? allProductBaseData.value : null,
          );
          setTimeout(() => {
            const lastElement = Array.from(
              document.querySelectorAll(
                ".anchor_list_container .anchor_btn.active",
              ),
            ).pop();
            if (lastElement) {
              lastElement.click();
            }
          }, 300);
        }
      },
      { deep: true },
    );

    void fetchData();

    return {
      data,
      loading,
      error,
      filters,
      resetAllFilters,
      fetchData,
      updateFilters,
      filteredData,
      filteredDataByGroup,
      destinationNavModel,
      promoRenderSignature,
      shopInfo,
      topBannerData,
      promoData,
      marketingData,
      hasTopicWrapData,
      isTopicWrapResolved,
      isQuickNavResolved,
      quickData,
      flightData,
      followedData,
      user,
      prom,
      sarea,
      oarea,
      beforeSarea,
      correspond,
      shopCode,
      allProductBaseData,
      allProductData,
      web: ref(bootstrap.webDesignUse),
    };
  },
});

createAppInstance.mount("#app");
